export type SecurityCodeFormFormShape = {
  code: string
}

export type SecurityCodeFormProps = {
  onSubmit: (value: SecurityCodeFormFormShape) => Promise<any>
  onRetryChallenge: () => any
  logoElement: React.ReactElement
}
